export default __webpack_public_path__ + "media/signIn.25cf86f1.png";